import { RestRepository } from "../../base/RestRepository";
import defaultConfig from "../../config";

const PaymentsRepository = new RestRepository({
  version: "v1",
  isPublic: false,
  path: "payment-methods",
  baseURL: defaultConfig.api.url,
});

export { PaymentsRepository };
